module.exports = __webpack_public_path__ + "static/media/safety-reman-3.c3dcae29.png";